import { DownOutlined, GlobalOutlined } from "@ant-design/icons"
import { Dropdown } from "antd"
import React, { useEffect, useState } from "react"
import { useLanguageContext } from "./context/LanguageContext"
import { useTranslation } from "react-i18next"

export default ({ style }: { style?: React.CSSProperties }) => {
  const { getLocales, changeLanguage, lang } = useLanguageContext()
  const { t } = useTranslation()
  const [langItems, setLangItems] = useState([])

  useEffect(() => {
    getLocales().then((locs) =>
      setLangItems(
        locs.map((locale) => ({
          label: t(`common.lang.${locale}`),
          onClick: () => changeLanguage(locale),
        }))
      )
    )
  }, [lang])

  const displayLang = lang?.split("-")[0] || lang

  return (
    <Dropdown menu={{ items: langItems }} trigger={["click"]}>
      <a onClick={(e) => e.preventDefault()} style={style}>
        <GlobalOutlined style={{ marginRight: 4 }} />{displayLang.toUpperCase()} <DownOutlined />
      </a>
    </Dropdown>
  )
}
